export default __webpack_public_path__ + "static/media/razorpay_logo.8c02e643.webp";